// Generated by CoffeeScript 1.6.3
(function() {
  var StateMetaobject, state;

  state = require('./state-function');

  module.exports = StateMetaobject = (function() {
    var useDispatchTables;

    useDispatchTables = state.options.useDispatchTables;

    function StateMetaobject() {
      this.parastates = null;
      this.data = null;
      this.methods = null;
      this.events = null;
      this.guards = null;
      this.substates = null;
      this.transitions = null;
      if (useDispatchTables) {
        this.__dispatch_table__ = null;
      }
    }

    return StateMetaobject;

  })();

}).call(this);
